import React from 'react';
import PageHead from 'components/misc/PageHead';

// Components.
import Page from 'components/misc/BasePage';
import RewardsContent from 'pageContents/RewardsContent';

const Rewards = () => {
  return (
    <Page>
      <PageHead />
      <RewardsContent />
    </Page>
  );
};

export default Rewards;
